import { Injectable } from '@angular/core';
import { PI } from '../../constants-types';
import { ApiService } from '../Api.service';
import { MfaRequest, MfaResponse } from './MfaApi.service';

@Injectable({ providedIn: 'root' })
export class MfaApiConnect {
    private accountManagementApiPrefix = '/api/v1';

    constructor(private api: ApiService) {}

    async setMfaStateByCompanyGuid(companyGuid: string, isMfaEnabled: boolean) {
        return this.api
            .put<
                MfaRequest,
                MfaResponse
            >(`${this.accountManagementApiPrefix}/companies/${companyGuid}/mfa`, { isMfaEnabled }, PI.appSettings.accountManagementApiUrl)
            .then(([data]) => data);
    }
}
